import React from "react";
import { useNavigate } from "react-router-dom";

export const Schedule = () => {
  const navigate = useNavigate();

  const styles = {
    timetable: {
      border: "none",
      borderBottom: "1px solid black",
    },
    timetableColumn: {
      width: "12.5%",
      border: "none",
    },
    workshop: {
      backgroundColor: "lightblue",
      border: "none",
      borderRight: "1px solid black",
      width: "12.5%",
    },
    break: {
      backgroundColor: "violet",
      border: "none",
      width: "12.5%",
      borderRight: "1px solid black",
    },
    phdForum: {
      backgroundColor: "pink",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    welcome: {
      backgroundColor: "#EEE82C",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    keynote: {
      backgroundColor: "#B8B42D",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    sessions: {
      backgroundColor: "#D0FEF5",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    poster: {
      backgroundColor: "#FFC6AC",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    panel: {
      backgroundColor: "#FF934F",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
    },
    tutorial: {
      backgroundColor: "#3D405B",
      width: "12.5%",
      border: "none",
      borderRight: "1px solid black",
      color: "#ffffff",
    },
    rowWorkshop: {
      border: "none",
      width: "12.5%",
    },
  };

  return (
    <>
      <table style={styles.timetable}>
        <tr style={{ border: "none" }}>
          <th></th>

          <th colSpan={2}>Monday, Venue: MTU</th>
          <th colSpan={2}>Tuesday, Venue: UCC</th>
          <th>Wednesday, Venue: UCC</th>
          <th colSpan={2}>Thursday, Venue: UCC</th>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>9:00-9:30</td>
          <td style={styles.workshop}>Workshops at MTU</td>
          <td style={styles.phdForum}>PhD Forum at MTU</td>
          <td style={styles.welcome}>Conference Welcome</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.panel}>Panel</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>9:30-10:00</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.keynote}>Keynote: Akane Sano</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.keynote}>Keynote: Vinny Cahill</td>
          <td style={styles.panel}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>10:00-10:30</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.keynote}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.keynote}></td>
          <td style={styles.panel}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>10:30-11:00</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>

          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>11:00-11:30</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.sessions}>
            Session 1 - Energy-aware Smart Systems
          </td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.sessions}>Session 3 - Best Papers</td>
          <td style={styles.sessions}>
            Session 6 -Learning, Sensing, and Orchestration
          </td>
          <td style={styles.tutorial}>Tutorial 2(a)</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>11:30-12:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.tutorial}>Secure & Smart Distributed Computing</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>12:00-12:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.tutorial}>(Agentic AI & Blockchain)</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>12:30-13:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>

          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>13:00-13:30</td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}></td>
          <td style={styles.break}></td>

          <td style={styles.break}></td>
          <td style={styles.break}></td>
          <td style={styles.break}></td>
        </tr>

        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>13:30-14:00</td>
          <td style={styles.break}></td>
          <td style={styles.break}></td>
          <td style={styles.sessions}>Session 2 - Industry Paper Session</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}>
            Session 4 - Intelligent Transportation Systems
          </td>
          <td style={styles.sessions}>
            Session 7 - Smart Multimodal Computing for Behavioural Insights
          </td>{" "}
          <td style={styles.tutorial}>Tutorial 2(b)</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>14:00-14:30</td>
          <td style={styles.workshop}>Workshops at MTU</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.tutorial}>Secure & Smart Distributed Computing</td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>14:30-15:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.tutorial}>
            (LoRaWAN – Practical Applications & EU Research)
          </td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>15:00-15:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}>Coffee Break</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>15:30-16:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}>Poster/Demo Session</td>
          <td style={styles.tutorial}>Tutorial 1</td>

          <td style={styles.sessions}>Session 5 - Smart Modelling of CPS</td>
          <td style={styles.welcome}>Conference Close</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>16:00-16:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}></td>
          <td style={styles.tutorial}>Human-Centered Research</td>

          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>16:30-17:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}></td>
          <td style={styles.tutorial}>with Smartphones and Wearables</td>

          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>17:00-17:30</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>17:30-18:00</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>18:00-18:30</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>18:30-19:00</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}>Dinner at Aula Maxima, UCC</td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "1px dashed #687b2f" }}>
          <td>19:00-19:30</td>
          <td style={styles.break}>Reception at Cork City Gaol</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>19:30-20:00</td>
          <td style={styles.break}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}></td>

          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
      </table>
    </>
  );
};
